// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { AudioSiteContent, CarouselItem, EventPointOfInterest, GenericPointOfInterest, Mood, Stop, StopPointOfInterest, Tour, TourCategory, VisitorType } from "generated/mos/org/getty/audio";
import { Page } from "generated/mos/pagination";
import { BundleType, BundleTypeValues } from "generated/mos/releasecontrols";
import { Codec, DecodeContext, RemoteObject, WebRPCError, decodeMessageRepeated, ensureScalar, ensureScalarOptional, ensureScalarRepeated, stripTypePropertyDeep } from "generated/webrpc";

export namespace GetAudioSiteContentRequest {
  export const refName = "mos.org.getty.audio_access.GetAudioSiteContentRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly audioSiteContentRef: { readonly typename: 'mos.org.getty.audio.AudioSiteContent', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    audioSiteContentRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetAudioSiteContentRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["audioSiteContentRef"] = v["audioSiteContentRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetAudioSiteContentResponse {
  export const refName = "mos.org.getty.audio_access.GetAudioSiteContentResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly audioSiteContent: AudioSiteContent.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    audioSiteContent: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetAudioSiteContentResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["audioSiteContent"] = ctx.decode(AudioSiteContent.codec, v["audioSiteContent"], "audioSiteContent");
      return out as any as Entity;
    }
  }();
}

export namespace GetCarouselItemRequest {
  export const refName = "mos.org.getty.audio_access.GetCarouselItemRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly carouselItemRef: { readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    carouselItemRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetCarouselItemRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["carouselItemRef"] = v["carouselItemRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetCarouselItemResponse {
  export const refName = "mos.org.getty.audio_access.GetCarouselItemResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly carouselItem: CarouselItem.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    carouselItem: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["carouselItem"] = CarouselItem.codec.encode(v.carouselItem);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetCarouselItemResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["carouselItem"] = ctx.decode(CarouselItem.codec, v["carouselItem"], "carouselItem");
      return out as any as Entity;
    }
  }();
}

export namespace GetEventPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_access.GetEventPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointOfInterestRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetEventPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointOfInterestRef"] = v["eventPointOfInterestRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetEventPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_access.GetEventPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointOfInterest: EventPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["eventPointOfInterest"] = EventPointOfInterest.codec.encode(v.eventPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetEventPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointOfInterest"] = ctx.decode(EventPointOfInterest.codec, v["eventPointOfInterest"], "eventPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace GetGenericPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_access.GetGenericPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointOfInterestRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetGenericPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointOfInterestRef"] = v["genericPointOfInterestRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetGenericPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_access.GetGenericPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointOfInterest: GenericPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["genericPointOfInterest"] = GenericPointOfInterest.codec.encode(v.genericPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetGenericPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointOfInterest"] = ctx.decode(GenericPointOfInterest.codec, v["genericPointOfInterest"], "genericPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace GetMoodRequest {
  export const refName = "mos.org.getty.audio_access.GetMoodRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly moodRef: { readonly typename: 'mos.org.getty.audio.Mood', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    moodRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetMoodRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["moodRef"] = v["moodRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetMoodResponse {
  export const refName = "mos.org.getty.audio_access.GetMoodResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly mood: Mood.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    mood: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["mood"] = Mood.codec.encode(v.mood);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetMoodResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["mood"] = ctx.decode(Mood.codec, v["mood"], "mood");
      return out as any as Entity;
    }
  }();
}

export namespace GetStopPointOfInterestRequest {
  export const refName = "mos.org.getty.audio_access.GetStopPointOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointOfInterestRef: { readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointOfInterestRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetStopPointOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointOfInterestRef"] = v["stopPointOfInterestRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetStopPointOfInterestResponse {
  export const refName = "mos.org.getty.audio_access.GetStopPointOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointOfInterest: StopPointOfInterest.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointOfInterest: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stopPointOfInterest"] = StopPointOfInterest.codec.encode(v.stopPointOfInterest);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetStopPointOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointOfInterest"] = ctx.decode(StopPointOfInterest.codec, v["stopPointOfInterest"], "stopPointOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace GetStopRequest {
  export const refName = "mos.org.getty.audio_access.GetStopRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopRef: { readonly typename: 'mos.org.getty.audio.Stop', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stopRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetStopRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopRef"] = v["stopRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetStopResponse {
  export const refName = "mos.org.getty.audio_access.GetStopResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stop: Stop.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    stop: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stop"] = Stop.codec.encode(v.stop);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetStopResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stop"] = ctx.decode(Stop.codec, v["stop"], "stop");
      return out as any as Entity;
    }
  }();
}

export namespace GetTourCategoryRequest {
  export const refName = "mos.org.getty.audio_access.GetTourCategoryRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategoryRef: { readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategoryRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetTourCategoryRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategoryRef"] = v["tourCategoryRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetTourCategoryResponse {
  export const refName = "mos.org.getty.audio_access.GetTourCategoryResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategory: TourCategory.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategory: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategory"] = TourCategory.codec.encode(v.tourCategory);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetTourCategoryResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategory"] = ctx.decode(TourCategory.codec, v["tourCategory"], "tourCategory");
      return out as any as Entity;
    }
  }();
}

export namespace GetTourRequest {
  export const refName = "mos.org.getty.audio_access.GetTourRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourRef: { readonly typename: 'mos.org.getty.audio.Tour', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tourRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetTourRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourRef"] = v["tourRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetTourResponse {
  export const refName = "mos.org.getty.audio_access.GetTourResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tour: Tour.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    tour: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tour"] = Tour.codec.encode(v.tour);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetTourResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tour"] = ctx.decode(Tour.codec, v["tour"], "tour");
      return out as any as Entity;
    }
  }();
}

export namespace GetVisitorTypeRequest {
  export const refName = "mos.org.getty.audio_access.GetVisitorTypeRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorTypeRef: { readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorTypeRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetVisitorTypeRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorTypeRef"] = v["visitorTypeRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetVisitorTypeResponse {
  export const refName = "mos.org.getty.audio_access.GetVisitorTypeResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorType: VisitorType.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    visitorType: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.GetVisitorTypeResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorType"] = ctx.decode(VisitorType.codec, v["visitorType"], "visitorType");
      return out as any as Entity;
    }
  }();
}

export namespace ListAudioSiteContentsRequest {
  export const refName = "mos.org.getty.audio_access.ListAudioSiteContentsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListAudioSiteContentsRequest.ByRef.Entity | ListAudioSiteContentsRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListAudioSiteContentsRequest.ByRef") {
            obj["byRef"] = ListAudioSiteContentsRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListAudioSiteContentsRequest.BySite") {
            obj["bySite"] = ListAudioSiteContentsRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListAudioSiteContentsRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListAudioSiteContentsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListAudioSiteContentsRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListAudioSiteContentsRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListAudioSiteContentsRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly audioSiteContentRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.AudioSiteContent', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      audioSiteContentRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListAudioSiteContentsRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["audioSiteContentRefs"] = v["audioSiteContentRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySite {
    export const refName = "mos.org.getty.audio_access.ListAudioSiteContentsRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListAudioSiteContentsRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListAudioSiteContentsResponse {
  export const refName = "mos.org.getty.audio_access.ListAudioSiteContentsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly audioSiteContents: ReadonlyArray<AudioSiteContent.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    audioSiteContents: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListAudioSiteContentsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["audioSiteContents"] = decodeMessageRepeated(ctx, AudioSiteContent.codec, v["audioSiteContents"], "audioSiteContents");
      return out as any as Entity;
    }
  }();
}

export namespace ListCarouselItemsRequest {
  export const refName = "mos.org.getty.audio_access.ListCarouselItemsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListCarouselItemsRequest.ListCarouselItemsFilter.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListCarouselItemsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["filter"] = ctx.decode(ListCarouselItemsRequest.ListCarouselItemsFilter.codec, v["filter"], "filter");
      return out as any as Entity;
    }
  }();
  export namespace ListCarouselItemsFilter {
    export const refName = "mos.org.getty.audio_access.ListCarouselItemsRequest.ListCarouselItemsFilter" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly byRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.CarouselItem', readonly id: string }>,
      readonly byStops: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      byRefs: [],
      byStops: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListCarouselItemsRequest.ListCarouselItemsFilter");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["byRefs"] = v["byRefs"];
        out["byStops"] = v["byStops"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListCarouselItemsResponse {
  export const refName = "mos.org.getty.audio_access.ListCarouselItemsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly carouselItems: ReadonlyArray<CarouselItem.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    carouselItems: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["carouselItems"] = [];
      for (const item of v.carouselItems) {
        obj["carouselItems"].push(CarouselItem.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListCarouselItemsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["carouselItems"] = decodeMessageRepeated(ctx, CarouselItem.codec, v["carouselItems"], "carouselItems");
      return out as any as Entity;
    }
  }();
}

// EventPointOfInterest
export namespace ListEventPointsOfInterestRequest {
  export const refName = "mos.org.getty.audio_access.ListEventPointsOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListEventPointsOfInterestRequest.ByRef.Entity | ListEventPointsOfInterestRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListEventPointsOfInterestRequest.ByRef") {
            obj["byRef"] = ListEventPointsOfInterestRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListEventPointsOfInterestRequest.BySite") {
            obj["bySite"] = ListEventPointsOfInterestRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListEventPointsOfInterestRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListEventPointsOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListEventPointsOfInterestRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListEventPointsOfInterestRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListEventPointsOfInterestRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly eventPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.EventPointOfInterest', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      eventPointsOfInterestRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListEventPointsOfInterestRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["eventPointsOfInterestRefs"] = v["eventPointsOfInterestRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySite {
    export const refName = "mos.org.getty.audio_access.ListEventPointsOfInterestRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListEventPointsOfInterestRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListEventPointsOfInterestResponse {
  export const refName = "mos.org.getty.audio_access.ListEventPointsOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly eventPointsOfInterest: ReadonlyArray<EventPointOfInterest.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    eventPointsOfInterest: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["eventPointsOfInterest"] = [];
      for (const item of v.eventPointsOfInterest) {
        obj["eventPointsOfInterest"].push(EventPointOfInterest.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListEventPointsOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["eventPointsOfInterest"] = decodeMessageRepeated(ctx, EventPointOfInterest.codec, v["eventPointsOfInterest"], "eventPointsOfInterest");
      return out as any as Entity;
    }
  }();
}

// GenericPointOfInterest
export namespace ListGenericPointsOfInterestRequest {
  export const refName = "mos.org.getty.audio_access.ListGenericPointsOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListGenericPointsOfInterestRequest.ByRef.Entity | ListGenericPointsOfInterestRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.ByRef") {
            obj["byRef"] = ListGenericPointsOfInterestRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.BySite") {
            obj["bySite"] = ListGenericPointsOfInterestRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListGenericPointsOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListGenericPointsOfInterestRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListGenericPointsOfInterestRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly genericPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.GenericPointOfInterest', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      genericPointsOfInterestRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["genericPointsOfInterestRefs"] = v["genericPointsOfInterestRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySite {
    export const refName = "mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListGenericPointsOfInterestRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListGenericPointsOfInterestResponse {
  export const refName = "mos.org.getty.audio_access.ListGenericPointsOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly genericPointsOfInterest: ReadonlyArray<GenericPointOfInterest.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    genericPointsOfInterest: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["genericPointsOfInterest"] = [];
      for (const item of v.genericPointsOfInterest) {
        obj["genericPointsOfInterest"].push(GenericPointOfInterest.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListGenericPointsOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["genericPointsOfInterest"] = decodeMessageRepeated(ctx, GenericPointOfInterest.codec, v["genericPointsOfInterest"], "genericPointsOfInterest");
      return out as any as Entity;
    }
  }();
}

export namespace ListMoodsRequest {
  export const refName = "mos.org.getty.audio_access.ListMoodsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Passing an invalid SortOrder will cause an INVALID_ARGUMENT error to be raised.
    readonly sortOrder: ListMoodsRequest.SortOrder,
    readonly filter: ListMoodsRequest.ByRef.Entity | ListMoodsRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    sortOrder: "SORT_DEFAULT",
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["sortOrder"] = v.sortOrder;
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListMoodsRequest.ByRef") {
            obj["byRef"] = ListMoodsRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListMoodsRequest.BySite") {
            obj["bySite"] = ListMoodsRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListMoodsRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListMoodsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        const ev = ensureScalar(ctx, v["sortOrder"], "string") || defaults["sortOrder"];
        if (!ListMoodsRequest.SortOrderValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListMoodsRequest.SortOrder`);
        }
        out["sortOrder"] = ev as any;
      }
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListMoodsRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListMoodsRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListMoodsRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly moodRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Mood', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      moodRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListMoodsRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["moodRefs"] = v["moodRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySite {
    export const refName = "mos.org.getty.audio_access.ListMoodsRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListMoodsRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

  export const SortOrderValues = new Set([
    'SORT_DEFAULT' as const,
    'SORT_MODIFIED_ASC' as const,
    'SORT_MODIFIED_DESC' as const,
  ]);
  export type SortOrder = typeof SortOrderValues extends Set<infer U> ? U : never;

}

export namespace ListMoodsResponse {
  export const refName = "mos.org.getty.audio_access.ListMoodsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly moods: ReadonlyArray<Mood.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    moods: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["moods"] = [];
      for (const item of v.moods) {
        obj["moods"].push(Mood.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListMoodsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["moods"] = decodeMessageRepeated(ctx, Mood.codec, v["moods"], "moods");
      return out as any as Entity;
    }
  }();
}

// StopPointOfInterest
export namespace ListStopPointsOfInterestRequest {
  export const refName = "mos.org.getty.audio_access.ListStopPointsOfInterestRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListStopPointsOfInterestRequest.ByRef.Entity | ListStopPointsOfInterestRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListStopPointsOfInterestRequest.ByRef") {
            obj["byRef"] = ListStopPointsOfInterestRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListStopPointsOfInterestRequest.BySite") {
            obj["bySite"] = ListStopPointsOfInterestRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListStopPointsOfInterestRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopPointsOfInterestRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListStopPointsOfInterestRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListStopPointsOfInterestRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListStopPointsOfInterestRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly stopPointsOfInterestRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.StopPointOfInterest', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      stopPointsOfInterestRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopPointsOfInterestRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["stopPointsOfInterestRefs"] = v["stopPointsOfInterestRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySite {
    export const refName = "mos.org.getty.audio_access.ListStopPointsOfInterestRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopPointsOfInterestRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListStopPointsOfInterestResponse {
  export const refName = "mos.org.getty.audio_access.ListStopPointsOfInterestResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stopPointsOfInterest: ReadonlyArray<StopPointOfInterest.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    stopPointsOfInterest: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stopPointsOfInterest"] = [];
      for (const item of v.stopPointsOfInterest) {
        obj["stopPointsOfInterest"].push(StopPointOfInterest.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopPointsOfInterestResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stopPointsOfInterest"] = decodeMessageRepeated(ctx, StopPointOfInterest.codec, v["stopPointsOfInterest"], "stopPointsOfInterest");
      return out as any as Entity;
    }
  }();
}

// Stop
export namespace ListStopsRequest {
  export const refName = "mos.org.getty.audio_access.ListStopsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly page: Page.Entity | undefined,
    // Passing an invalid SortOrder will cause an INVALID_ARGUMENT error to be raised.
    readonly sortOrder: ListStopsRequest.SortOrder,
    readonly filter: ListStopsRequest.ListStopFilter.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    page: undefined,
    sortOrder: "SORT_DEFAULT",
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["page"] = ctx.decode(Page.codec, v["page"], "page");
      {
        const ev = ensureScalar(ctx, v["sortOrder"], "string") || defaults["sortOrder"];
        if (!ListStopsRequest.SortOrderValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListStopsRequest.SortOrder`);
        }
        out["sortOrder"] = ev as any;
      }
      out["filter"] = ctx.decode(ListStopsRequest.ListStopFilter.codec, v["filter"], "filter");
      return out as any as Entity;
    }
  }();
  export namespace ListStopFilter {
    export const refName = "mos.org.getty.audio_access.ListStopsRequest.ListStopFilter" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly byRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
      readonly bySites: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
      readonly byTours: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
      readonly excludeByRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Stop', readonly id: string }>,
      readonly byInTour: ListStopsRequest.ListStopFilter.BooleanFlag,
      readonly searchText: string | undefined,
      readonly byHasLocation: ListStopsRequest.ListStopFilter.BooleanFlag,
      readonly byHasIssues: ListStopsRequest.ListStopFilter.BooleanFlag,
      readonly byIncludedInBundle: ReadonlyArray<BundleType>,
      readonly byInABundle: ListStopsRequest.ListStopFilter.BooleanFlag,
      readonly byRecentlyUpdated: ListStopsRequest.ListStopFilter.BooleanFlag,
      readonly byMoods: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Mood', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      byRefs: [],
      bySites: [],
      byTours: [],
      excludeByRefs: [],
      byInTour: "BOOLEAN_FLAG_IGNORE",
      searchText: undefined,
      byHasLocation: "BOOLEAN_FLAG_IGNORE",
      byHasIssues: "BOOLEAN_FLAG_IGNORE",
      byIncludedInBundle: [],
      byInABundle: "BOOLEAN_FLAG_IGNORE",
      byRecentlyUpdated: "BOOLEAN_FLAG_IGNORE",
      byMoods: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopsRequest.ListStopFilter");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["byRefs"] = v["byRefs"];
        out["bySites"] = v["bySites"];
        out["byTours"] = v["byTours"];
        out["excludeByRefs"] = v["excludeByRefs"];
        {
          const ev = ensureScalar(ctx, v["byInTour"], "string") || defaults["byInTour"];
          if (!ListStopsRequest.ListStopFilter.BooleanFlagValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListStopsRequest.ListStopFilter.BooleanFlag`);
          }
          out["byInTour"] = ev as any;
        }
        out["searchText"] = ensureScalarOptional(ctx, v["searchText"], "string");
        {
          const ev = ensureScalar(ctx, v["byHasLocation"], "string") || defaults["byHasLocation"];
          if (!ListStopsRequest.ListStopFilter.BooleanFlagValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListStopsRequest.ListStopFilter.BooleanFlag`);
          }
          out["byHasLocation"] = ev as any;
        }
        {
          const ev = ensureScalar(ctx, v["byHasIssues"], "string") || defaults["byHasIssues"];
          if (!ListStopsRequest.ListStopFilter.BooleanFlagValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListStopsRequest.ListStopFilter.BooleanFlag`);
          }
          out["byHasIssues"] = ev as any;
        }
        {
          const evs = ensureScalarRepeated(ctx, v["byIncludedInBundle"], "string").map(i => i || defaults["byIncludedInBundle"]);
          for (const ev of evs) {
            if (!BundleTypeValues.has(ev as any)) {
              throw ctx.error(`unknown value "${ev}" for enum .mos.release_controls.BundleType`);
            }
          }
          out["byIncludedInBundle"] = evs as any;
        }
        {
          const ev = ensureScalar(ctx, v["byInABundle"], "string") || defaults["byInABundle"];
          if (!ListStopsRequest.ListStopFilter.BooleanFlagValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListStopsRequest.ListStopFilter.BooleanFlag`);
          }
          out["byInABundle"] = ev as any;
        }
        {
          const ev = ensureScalar(ctx, v["byRecentlyUpdated"], "string") || defaults["byRecentlyUpdated"];
          if (!ListStopsRequest.ListStopFilter.BooleanFlagValues.has(ev as any)) {
            throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListStopsRequest.ListStopFilter.BooleanFlag`);
          }
          out["byRecentlyUpdated"] = ev as any;
        }
        out["byMoods"] = v["byMoods"];
        return out as any as Entity;
      }
    }();
    export const BooleanFlagValues = new Set([
      'BOOLEAN_FLAG_IGNORE' as const,
      'BOOLEAN_FLAG_TRUE' as const,
      'BOOLEAN_FLAG_FALSE' as const,
    ]);
    export type BooleanFlag = typeof BooleanFlagValues extends Set<infer U> ? U : never;

  }

  export const SortOrderValues = new Set([
    'SORT_DEFAULT' as const,
    'SORT_TITLE_ASC' as const,
    'SORT_MODIFIED_DESC' as const,
  ]);
  export type SortOrder = typeof SortOrderValues extends Set<infer U> ? U : never;

}

export namespace ListStopsResponse {
  export const refName = "mos.org.getty.audio_access.ListStopsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly stops: ReadonlyArray<Stop.Entity>,
    readonly nextPage: Page.Entity | undefined,
    // Estimated number of available results, after search queries and filtering but before pagination.
    // This may change during pagination, and should not be relied upon for list termination.
    readonly totalItems: number,
  }
  export const defaults: Entity = {
    type: refName,
    stops: [],
    nextPage: undefined,
    totalItems: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["stops"] = [];
      for (const item of v.stops) {
        obj["stops"].push(Stop.codec.encode(item));
      }
      obj["nextPage"] = Page.codec.encode(v.nextPage);
      obj["totalItems"] = v.totalItems;
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListStopsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["stops"] = decodeMessageRepeated(ctx, Stop.codec, v["stops"], "stops");
      out["nextPage"] = ctx.decode(Page.codec, v["nextPage"], "nextPage");
      out["totalItems"] = ensureScalar(ctx, v["totalItems"], "number");
      return out as any as Entity;
    }
  }();
}

export namespace ListTourCategoriesRequest {
  export const refName = "mos.org.getty.audio_access.ListTourCategoriesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListTourCategoriesRequest.ByRef.Entity | ListTourCategoriesRequest.BySite.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListTourCategoriesRequest.ByRef") {
            obj["byRef"] = ListTourCategoriesRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListTourCategoriesRequest.BySite") {
            obj["bySite"] = ListTourCategoriesRequest.BySite.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListTourCategoriesRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListTourCategoriesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListTourCategoriesRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySite"] !== undefined) {
          out["filter"] = ctx.decode(ListTourCategoriesRequest.BySite.codec, v["bySite"], "bySite");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListTourCategoriesRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly tourCategoryRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      tourCategoryRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListTourCategoriesRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["tourCategoryRefs"] = v["tourCategoryRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySite {
    export const refName = "mos.org.getty.audio_access.ListTourCategoriesRequest.BySite" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListTourCategoriesRequest.BySite");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListTourCategoriesResponse {
  export const refName = "mos.org.getty.audio_access.ListTourCategoriesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tourCategories: ReadonlyArray<TourCategory.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    tourCategories: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tourCategories"] = [];
      for (const item of v.tourCategories) {
        obj["tourCategories"].push(TourCategory.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListTourCategoriesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tourCategories"] = decodeMessageRepeated(ctx, TourCategory.codec, v["tourCategories"], "tourCategories");
      return out as any as Entity;
    }
  }();
}

export namespace ListToursRequest {
  export const refName = "mos.org.getty.audio_access.ListToursRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Passing an invalid SortOrder will cause an INVALID_ARGUMENT error to be raised.
    readonly sortOrder: ListToursRequest.SortOrder,
    readonly filter: ListToursRequest.ByRef.Entity | ListToursRequest.BySiteAndCategory.Entity | ListToursRequest.ByTourCategory.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    sortOrder: "SORT_DEFAULT",
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["sortOrder"] = v.sortOrder;
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListToursRequest.ByRef") {
            obj["byRef"] = ListToursRequest.ByRef.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListToursRequest.BySiteAndCategory") {
            obj["bySiteAndCategory"] = ListToursRequest.BySiteAndCategory.codec.encode(uv);
          }
          else if (uv.type == "mos.org.getty.audio_access.ListToursRequest.ByTourCategory") {
            obj["byTourCategory"] = ListToursRequest.ByTourCategory.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListToursRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListToursRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        const ev = ensureScalar(ctx, v["sortOrder"], "string") || defaults["sortOrder"];
        if (!ListToursRequest.SortOrderValues.has(ev as any)) {
          throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.audio_access.ListToursRequest.SortOrder`);
        }
        out["sortOrder"] = ev as any;
      }
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListToursRequest.ByRef.codec, v["byRef"], "byRef");
        }
        if (v["bySiteAndCategory"] !== undefined) {
          out["filter"] = ctx.decode(ListToursRequest.BySiteAndCategory.codec, v["bySiteAndCategory"], "bySiteAndCategory");
        }
        if (v["byTourCategory"] !== undefined) {
          out["filter"] = ctx.decode(ListToursRequest.ByTourCategory.codec, v["byTourCategory"], "byTourCategory");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListToursRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly tourRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.Tour', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      tourRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListToursRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["tourRefs"] = v["tourRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace BySiteAndCategory {
    export const refName = "mos.org.getty.audio_access.ListToursRequest.BySiteAndCategory" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly siteRefs: ReadonlyArray<{ readonly typename: 'mos.structure.Site', readonly id: string }>,
      readonly categoryRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      siteRefs: [],
      categoryRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListToursRequest.BySiteAndCategory");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["siteRefs"] = v["siteRefs"];
        out["categoryRefs"] = v["categoryRefs"];
        return out as any as Entity;
      }
    }();
  }

  export namespace ByTourCategory {
    export const refName = "mos.org.getty.audio_access.ListToursRequest.ByTourCategory" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly tourCategoryRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.TourCategory', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      tourCategoryRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListToursRequest.ByTourCategory");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["tourCategoryRefs"] = v["tourCategoryRefs"];
        return out as any as Entity;
      }
    }();
  }

  export const SortOrderValues = new Set([
    'SORT_DEFAULT' as const,
    'SORT_MODIFIED_ASC' as const,
    'SORT_MODIFIED_DESC' as const,
  ]);
  export type SortOrder = typeof SortOrderValues extends Set<infer U> ? U : never;

}

export namespace ListToursResponse {
  export const refName = "mos.org.getty.audio_access.ListToursResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly tours: ReadonlyArray<Tour.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    tours: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["tours"] = [];
      for (const item of v.tours) {
        obj["tours"].push(Tour.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListToursResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["tours"] = decodeMessageRepeated(ctx, Tour.codec, v["tours"], "tours");
      return out as any as Entity;
    }
  }();
}

export namespace ListVisitorTypesRequest {
  export const refName = "mos.org.getty.audio_access.ListVisitorTypesRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly filter: ListVisitorTypesRequest.ByRef.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    filter: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.filter;
        if (uv !== undefined) {
          if (uv.type == "mos.org.getty.audio_access.ListVisitorTypesRequest.ByRef") {
            obj["byRef"] = ListVisitorTypesRequest.ByRef.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.audio_access.ListVisitorTypesRequest.filter");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListVisitorTypesRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["byRef"] !== undefined) {
          out["filter"] = ctx.decode(ListVisitorTypesRequest.ByRef.codec, v["byRef"], "byRef");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace ByRef {
    export const refName = "mos.org.getty.audio_access.ListVisitorTypesRequest.ByRef" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly visitorTypeRefs: ReadonlyArray<{ readonly typename: 'mos.org.getty.audio.VisitorType', readonly id: string }>,
    }
    export const defaults: Entity = {
      type: refName,
      visitorTypeRefs: [],
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListVisitorTypesRequest.ByRef");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["visitorTypeRefs"] = v["visitorTypeRefs"];
        return out as any as Entity;
      }
    }();
  }

}

export namespace ListVisitorTypesResponse {
  export const refName = "mos.org.getty.audio_access.ListVisitorTypesResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly visitorTypes: ReadonlyArray<VisitorType.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    visitorTypes: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.audio_access.ListVisitorTypesResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["visitorTypes"] = decodeMessageRepeated(ctx, VisitorType.codec, v["visitorTypes"], "visitorTypes");
      return out as any as Entity;
    }
  }();
}

